import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterArticle_template} from "./filterArticle_template";
import {amCharts_v4_category_line_template} from "./amCharts_v4_category_line_template";


declare var ko: any;

export interface ArticlePerformance {
    author: string;
    brand: string;
    contentType: string;
    datePublish: string;
    dateRange: number;
    daysCompletion: number;
    featuredImage: string;
    fromPublish: string;
    hasRepublish: string;
    idArticle: number;
    isFailure: string;
    isSuccessful: string;
    networkCategory: number;
    pageViews: string;
    sessions: string;
    styleClass: string;
    title: string;
}

export interface Views {
    author: string;
    date: string;
    views: number;
}

export class usersProfileArticlePerformance_template extends vnTemplate {

    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected dateFilter: filterDate_template;
    protected brandFilter : filterDropdown_template;
    protected publishTypesFilter : filterDropdown_template;
    protected pageTypesFilter : filterDropdown_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected contentTypesFilter : multipleSelector_template;
    protected articleFilter: filterArticle_template;
    protected dailyViews: amCharts_v4_category_line_template;
    protected paymentCategoryFilter: multipleSelector_template;
    protected dataRangeFilter : filterDropdown_template;
    protected sessionsRegionFilter : filterDropdown_template;

    protected getTemplateHtml(): string {

        return /* html */`

                <!-- Articles Performance -->
                <div data-bind="visible: visible">
                    <article  class="user-dashboard">
                        <div class="d-header sub-header">
                            <div class="d-header-title">
                                <i class="fal fa-file-alt"></i>
                                <div>
                                    <div class="d-section" data-bind="text: roleTitle() + ' Performance'"></div>
                                </div>
                            </div>
                            <div class="d-header-filters w-justify ">
                                <div class="d-header-specs w-left">
                                    <div>
                                        <label class="form-label form-label-box">Brands</label> ${ this.brandFilter.getHtmlBuild() }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div data-bind="css: { loading: isLoadingPerformance }, foreach: authorPerformanceItems" style="display: grid;grid-template-columns: 1fr 1fr 1fr;gap: 1rem;background-color: #f2f2f2;padding: 1rem;">
                            <!-- ko if: $data.isAuthorPerformance == true -->
                            <div class="form-body full-width compensation-tracker">
                                <div class="w-compensation-container" id="compensation-tracker-container">
                                    <div class="w-compensation" id="compensation-tracker">
                                        <div class="w-compensation-popover no-hover">
                                            <div class="w-compensation-content">
                                                <div class="w-compensation-title" data-bind="text: $parent.roleTitle() + ': ' + $data.monthName + ' Performance'"></div>
                                                <div class="w-compensation-metric"></div>
                                            </div>
                                            <div class="w-compensation-tracker">
                                                <div class="compensation-output">
                                                    <div>
                                                        <div class="label" style="margin-bottom: 4px;">Output</div>
                                                        <div class="value-article-output">
                                                            <div class="value" data-bind="text: $data.articleCount"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="compensation-sessions">
                                                    <div class="sessions-label">Sessions per Article
                                                            <span class="performance-value" data-bind="text: $data.articleSessions.toLocaleString('en-US')"></span>
                                                    </div>
                                                    <div class="sessions-performance">
                                                        <div class="sessions-performance-inner">
                                                            <div class="performance-progress-bar">
                                                                <div class="progress-bar-fill" data-bind="style: { '--pos': Math.min(($data.articleSessions / $data.articleTargetSessions) * 100, 100) + '%'}, css: { 'single-tier': true, 'tier-one-success': Math.min(($data.articleSessions / $data.articleTargetSessions) * 100, 100) == 100 }">
                                                                    <div class="w-user-img">
                                                                    <img class="user-img" data-bind="attr:{src: $parent.userPicture()}" src="/assets/images/default-user.png">
                                                                    </div>
                                                                </div>
                                                                <div class="tier">
                                                                    <span class="tier-label">Target</span>
                                                                    <span class="tier-value" data-bind="text: $data.articleTargetSessions.toLocaleString('en-US')"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /ko -->
                            <!-- ko if: $data.isAuthorCompensation == true -->
                            <div class="form-body full-width compensation-tracker">
                                <div class="w-compensation-container" id="compensation-tracker-container">
                                    <div class="w-compensation" id="compensation-tracker" data-bind="css: { 'output-success': $data.articleGoalProgressPercentage == 100 }">
                                        <div class="w-compensation-popover no-hover">
                                            <div class="w-compensation-content">
                                                <div class="w-compensation-title" data-bind="text: $parent.roleTitle() + ': ' + $data.monthName + ' Performance'"></div>
                                            </div>
                                            <div class="w-compensation-tracker">
                                                <div class="compensation-output">
                                                    <div>
                                                        <div class="label" style="margin-bottom: 4px;">Output</div>
                                                        <div class="value-article-output">
                                                            <div class="value-article-fill" data-bind="style: { height: $data.articleGoalProgressPercentage + '%'}, css: { 'progress-full': $data.articleGoalProgressPercentage == 100 }"></div>
                                                            <div class="value" data-bind="text: $data.articleCount"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="compensation-sessions">
                                                    <div class="sessions-label">Sessions per Article
                                                            <span class="performance-value" data-bind="text: $data.sessionsPerArticle.toLocaleString('en-US')"></span>
                                                    </div>
                                                    <div class="sessions-performance">
                                                        <div class="sessions-performance-inner">
                                                            <div class="performance-progress-bar">
                                                                <div class="progress-bar-fill" data-bind="style: { '--pos': $data.sessionGoalProgressPercentage + '%'}, css: { 'single-tier': !$data.isUserHasTier2Rates, 'tier-one-success': $data.sessionGoalProgressPercentage == 100, 'tier-two-success': $data.tier2SessionGoalProgressPercentage == 100 }">
                                                                    <div class="w-user-img">
                                                                        <img class="user-img" data-bind="attr:{src: $parent.userPicture()}" src="/assets/images/default-user.png">
                                                                    </div>
                                                                </div>
                                                                <div class="tier">
                                                                    <span class="tier-label">Tier 1</span>
                                                                    <span class="tier-value" data-bind="text: $data.sessionsPerArticleTarget.toLocaleString('en-US')"></span>
                                                                    <div class="tier-monetization icon i-lock" data-bind="text: '$' + $data.tier1Amount"></div>
                                                                </div>
                                                                <div class="tier" data-bind="visible: $data.isUserHasTier2Rates">
                                                                    <span class="tier-label">Tier 2</span>
                                                                    <span class="tier-value" data-bind="text: $data.tier2SessionsPerArticleTarget ? $data.tier2SessionsPerArticleTarget.toLocaleString('en-US') : ''"></span>
                                                                    <div class="tier-monetization icon i-lock" data-bind="text: '$' + $data.tier2Amount"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /ko -->
                        </div>

                        <div class="d-header" style="margin-bottom: 0rem">
                            <div class="d-header-title" style="margin-bottom: 0rem"><div class="d-section icon i-graph">Sessions in Active Period</div></div>
                        </div>
                        <div data-bind="css: { loading: isLoadingPerformance }">
                            ${this.dailyViews.getHtmlBuild()}
                        </div>
                    </article>

                    <article class="user-dashboard article-performance">
                        <div class="d-header sub-header">
                            <div class="d-header-title">
                                <i class="fal fa-file-alt"></i>
                                <div>
                                    <div class="d-section">Article performance</div>
                                </div>
                            </div>
                            <div class="d-header-filters w-justify">
                                <div class="d-header-specs w-left">
                                     ${this.dateFilter.getHtmlBuild()}
                                    <div>
                                        <label class="form-label form-label-box">Types</label> ${this.pageTypesFilter.getHtmlBuild()}
                                    </div>
                                    ${this.networkCategoriesFilter.getHtmlBuild()}
                                    ${this.contentTypesFilter.getHtmlBuild()}
                                    ${this.paymentCategoryFilter.getHtmlBuild()}
                                    <div>
                                        <label class="form-label form-label-box">Data Ranges</label> 
                                        ${this.dataRangeFilter.getHtmlBuild()}
                                    </div>
                                    <div>
                                        <label class="form-label form-label-box">Session Regions</label> 
                                        ${this.sessionsRegionFilter.getHtmlBuild()}
                                    </div>
                                    <div>
                                        <label class="form-label form-label-box">Publish Types</label> 
                                        ${ this.publishTypesFilter.getHtmlBuild() }
                                    </div>
                                    ${this.articleFilter.getHtmlBuild()}
                                </div>
                                <div class="d-header-pagination">
                                    ${this.pagination.getHtmlBuild()}
                                </div>
                            </div>
                              <div style="display:none;" id="filters-selected" class="filters-selected">
                               <div id="selected-content_types"></div>
                               <div id="selected-network_categories"></div>
                               <div id="selected-post_payment_categories"></div>
                            </div>
                        </div>
                        <div data-bind="css: { loading: isLoading }">
                            <div class="w-list-results" id="list-results">
                            <table class="list-results user-performance-article">
                                ${this.resultInfos.getHtmlBuild()}
                                <thead>
                                    <tr class="grand-total">
                                        <th class="section-end" colspan="5"><span>All pages totals</span></th>
                                        <th class="align-right"><span class="large" data-bind="text: (sessionsRegion() == 'us') ? Number(totalSessionsUS()).toLocaleString('en-US') : Number(totalSessions()).toLocaleString('en-US')"></span></th>
                                        <th class="align-right"><span class="large" data-bind="text: Number(totalSuccessTargetSessions()).toLocaleString('en-US')"></span></th>
                                        <th class="align-right"><span class="large" data-bind="text: Number(totalPageViews()).toLocaleString('en-US')"></span></th>
                                    </tr>
                                </thead>
                                <thead>
                                    <tr>
                                        <th><span class="icon">Title</span></th>
                                        <th class="section-end align-right">
                                            <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'datePublish') }, css: { 'list-sort-desc': orderByAndDirection()=='datePublish_DESC', 'list-sort-asc': orderByAndDirection()=='datePublish_ASC' }">Publish Date</span>
                                        </th>
                                        <th class="section-a">
                                            <span class="icon">Content type</span>
                                        </th>
                                        <th class="section-a">
                                            <span class="icon"> Network Category</span>
                                        </th>
                                        <th class="section-a section-end">
                                            <span class="icon"> Payment Category</span>
                                        </th>
                                        <th class="section-b align-right">
                                            <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sessions') }, css: { 'list-sort-desc': orderByAndDirection()=='sessions_DESC', 'list-sort-asc': orderByAndDirection()=='sessions_ASC' }">Active Sessions</span>
                                        </th>
                                        <th class="section-b align-right">
                                            <span class="icon">Target Sessions</span>
                                        </th>
                                        <th class="section-b align-right">
                                            <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'pageViews') }, css: { 'list-sort-desc': orderByAndDirection()=='pageViews_DESC', 'list-sort-asc': orderByAndDirection()=='pageViews_ASC' }">Active Pageviews</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: articlePerformanceItems">
                                    <tr class="cursor">
                                        <td class="flex">
                                            <a class="i-int-link" data-bind="attr: { href : '/brand/' + $parent.idBrand() + '/articles/view/' + idArticle }">
                                                <span class="icon i-link"></span>
                                                <span data-bind="text: title"></span>
                                            </a>
                                        </td>
                                        <td class="section-end align-right">
                                            <span data-bind="text: datePublish"></span>
                                        </td>
                                        <td class="section-a">
                                            <span data-bind="text: contentType"></span>
                                        </td>
                                        <td class="section-a">
                                            <span data-bind="text: String(networkCategory[0]).toUpperCase() + String(networkCategory).slice(1);"></span>
                                        </td>
                                        <td class="section-a section-end">
                                            <span data-bind="text: String(paymentCategory[0]).toUpperCase() + String(paymentCategory).slice(1);"></span>
                                        </td>
                                        <td class="section-b align-right">
                                            <span data-bind="attr: { title: $parent.sessionsRegion() },text: ($parent.sessionsRegion() == 'us') ? sessionsUS.toLocaleString('en-US') : sessions.toLocaleString('en-US')"></span>
                                        </td>
                                        <td class="section-b align-right">
                                            <span data-bind="text: new Intl.NumberFormat('en-US').format(successTargetSessions)"></span>
                                        </td>
                                        <td class="section-b align-right">
                                            <span data-bind="text: pageViews.toLocaleString('en-US')"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        </div>
                    </article>
                </div>
            `;
    }

    protected initPartial(): void {

        this.brandFilter = new filterDropdown_template("authorPerformanceAndArticlePerformance_brandFilter", this.getTemplateViewModel(), this.caller);

        this.pagination = new pagination_template("articlePerformance_pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 35;

        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        let currentDate = new Date();
        this.dateFilter = new filterDate_template("articlePerformance_dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setDateRange(
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 30),
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()),
        );

        this.publishTypesFilter = new filterDropdown_template("articlePerformance_publishTypesFilter", this.getTemplateViewModel(), this.caller);
        this.publishTypesFilter.setOptions([
            {id: 'all', name: 'All'},
            {id: 'newPublishes', name: 'New Publishes'},
            {id: 'republishes', name: 'Republishes'},
        ]);

        this.networkCategoriesFilter = new multipleSelector_template("articlePerformance_networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setFilterContainerClass('margin-neg');
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.pageTypesFilter = new filterDropdown_template("articlePerformance_pageTypesFilter", this.getTemplateViewModel(), this.caller);

        this.contentTypesFilter = new multipleSelector_template("articlePerformance_contentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypesFilter.setLabel("content types");
        this.contentTypesFilter.setFilterContainerClass('margin-neg');
        this.contentTypesFilter.setTagContainerId('selected-content_types');
        this.contentTypesFilter.setTagContainerCaption('Selected content types:');

        this.paymentCategoryFilter = new multipleSelector_template("articlePerformance_postPaymentCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.paymentCategoryFilter.setLabel("payment categories");
        this.paymentCategoryFilter.setFilterContainerClass('margin-neg');
        this.paymentCategoryFilter.setTagContainerId('selected-post_payment_categories');
        this.paymentCategoryFilter.setTagContainerCaption('Selected post payment categories:');

        this.dataRangeFilter = new filterDropdown_template("articlePerformance_dataRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dataRangeFilter.setOptions(this.buildSessionsRangesItems(30));
        this.dataRangeFilter.getTemplateViewModel().selectedOption(30);

        this.sessionsRegionFilter = new filterDropdown_template("articlePerformance_sessionsRegionFilter", this.getTemplateViewModel(), this.caller);
        this.sessionsRegionFilter.setOptions([
            {id: 'all', name: 'All Sessions'},
            {id: 'us', name: 'US Sessions'}
        ]);
        this.sessionsRegionFilter.getTemplateViewModel().selectedOption('all');

        this.articleFilter = new filterArticle_template("articlePerformance_articleFilter", this.getTemplateViewModel(), this.caller);

        this.dailyViews = new amCharts_v4_category_line_template("amCharts_v4_category_views_line_template", this.getTemplateViewModel(), this.caller);
        this.dailyViews.setXAxisRotation(-90);
        this.dailyViews.setXAxisFontSize(14);

    }

    protected buildSessionsRangesItems(maxDays) {
        let items = [];
        for (let i = maxDays; i > 0; i--) {
            items.push({id: i, name:  (i === 1) ? i + ' day' : i + ' days'});
        }
        return items;
    }

    protected getTemplateName(): string {

        return "usersProfileArticlePerformance-template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return [""];
    }

    protected buildViewModel(): any {

        let self = this;

        return {
            visible: ko.observable(false),
            hasData: ko.observable(false),
            brands: ko.observable([]),
            idBrand: ko.observable(""),
            isLoadingPerformance: ko.observable(0),
            isLoading: ko.observable(0),
            dailyViews: ko.observableArray([]),
            userPicture: ko.observable(""),
            orderBy: ko.observable("datePublish"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("datePublish_DESC"),
            articlePerformanceItems: ko.observableArray([]),
            authorPerformanceItems: ko.observableArray([]),
            totalSessions: ko.observable(0),
            totalSessionsUS: ko.observable(0),
            totalSuccessTargetSessions: ko.observable(0),
            totalPageViews: ko.observable(0),
            roleTitle: ko.observable(''),
            sessionsRegion: ko.observable('all'),
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            }
        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);

        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.getUserArticlePerformanceData();
    }

    public getViewModelForRequest() {

        return {
            pagination: this.getTemplateViewModel().articlePerformance_pagination,
            sorting: {
                orderBy: this.getTemplateViewModel().orderBy,
                orderByDirection: this.getTemplateViewModel().orderByDirection,
                orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            },
            filters : {
                pageType : this.getTemplateViewModel().articlePerformance_pageTypesFilter.selectedOption,
                networkCategories : this.getTemplateViewModel().articlePerformance_networkCategoriesFilter.selectedItems,
                publishTypes : this.getTemplateViewModel().articlePerformance_publishTypesFilter.selectedOption,
                contentTypes: this.getTemplateViewModel().articlePerformance_contentTypesFilter.selectedItems,
                startDate: this.getTemplateViewModel().articlePerformance_dateFilter.startDate(),
                endDate: this.getTemplateViewModel().articlePerformance_dateFilter.endDate(),
                idArticle: this.getTemplateViewModel().articlePerformance_articleFilter.idArticle,
                idBrand: this.getTemplateViewModel().authorPerformanceAndArticlePerformance_brandFilter.selectedOption,
                paymentCategories: this.getTemplateViewModel().articlePerformance_postPaymentCategoryFilter.selectedItems,
                dataRange : this.getTemplateViewModel().articlePerformance_dataRangeFilter.selectedOption,
                sessionsRegion : this.getTemplateViewModel().articlePerformance_sessionsRegionFilter.selectedOption
            }
        }
    }

    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setUserPicture(userPicture): void {

        this.getTemplateViewModel().userPicture(userPicture);
    }

    public setAuthorPerformance(authorPerformance): void {

        this.getTemplateViewModel().authorPerformanceItems(authorPerformance);
    }

    public setIdBrand(idBrand): void {

        this.getTemplateViewModel().idBrand(idBrand);
    }

    public setTotalRow(totalRow): void {

        this.getTemplateViewModel().totalSessions(totalRow.sessions);
        this.getTemplateViewModel().totalSessionsUS(totalRow.sessionsUS);
        this.getTemplateViewModel().totalSuccessTargetSessions(totalRow.successTargetSessions);
        this.getTemplateViewModel().totalPageViews(totalRow.pageViews);

    }

    public setArticlePerformance(articlePerformance: Array<ArticlePerformance>): void {

        for (let p of articlePerformance) {

            p['styleClass'] = '';

            p['pageViews'] = Number(p.pageViews).toLocaleString(undefined, {minimumFractionDigits: 0});
            p['sessions'] = Number(p.sessions).toLocaleString(undefined, {minimumFractionDigits: 0});
            let publishType = (Number(p.fromPublish) == 1) ? 'Published on ' : 'Republished on ';
            p['datePublish'] = String(publishType).concat(p.datePublish.substring(0, 10));
            if (Number(p.hasRepublish) == 1 && Number(p.daysCompletion) < Number(p.dateRange)) {
                p['dateRange'] = Number(p.daysCompletion);
            }
        }

        this.getTemplateViewModel().articlePerformanceItems(articlePerformance);
    }

    public setPageTypesFilterItems(items){

        this.pageTypesFilter.setOptions(items);
    }

    public setNetworkCategoriesFilterItems(items){

        this.networkCategoriesFilter.setItems(items);
    }

    public setContentTypesFilterItems(items){

        this.contentTypesFilter.setItems(items);
    }

    public setPaymentCategoriesFilterItems(groupCategories){

        let groups = [];
        for ( let groupCategory of groupCategories){

            groups.push({"name" : groupCategory.name, "items" :groupCategory.paymentCategories});
        }
        this.paymentCategoryFilter.setMultiSectionItems(groups);
    }

    public setBrands(brands){

        let b = [];
        for (let brand of brands) {

            b[brand.name] = brand;
        }
        this.getTemplateViewModel().brands([]);
        this.getTemplateViewModel().brands(b);
    }

    public setBrandsFilterItems(items){

        let options = [];
        items.forEach((ar) => {
            options.push({id: ar.id, name: ar.name})
        });

        this.brandFilter.setOptions(options);
    }

    public setSelectedBrand(idBrand) {

        this.brandFilter.setSelectedOption(idBrand);
    }

    public setArticlesFilter(articles) {

        let data = [];
        for (let article of articles) {
            article.id = article.idArticle;
            data.push(article);
        }
        this.getTemplateViewModel().articlePerformance_articleFilter.articles(data);
    }

    public setVisible(visible) {

        this.getTemplateViewModel().visible(visible);
    }

    public setHasData(hasData) {

        this.getTemplateViewModel().hasData(hasData);
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendarWhenReady();
    }

    public isLoading(loading){

        this.getTemplateViewModel().isLoading(loading);
    }

    public isLoadingPerformance(loadingPerformance){

        this.getTemplateViewModel().isLoadingPerformance(loadingPerformance);
    }

    public setRoleTitle(roleTitle: string): void {
        this.getTemplateViewModel().roleTitle(roleTitle);
    }

    public setDailyViews(dailyViews: Array<Views>): void {
        this.getTemplateViewModel().dailyViews(dailyViews);
        this.dailyViews.setCategory('date');

        // set x axis
        let yaxis = [];


        yaxis.push({
            field: "repubSessions",
            name:  this.caller.getFullName() + ' Daily Republished Sessions',
            axis: "main",
            color: "#FFB30F",
            opposite: false
        });

        yaxis.push({
            field: "sessions",
            name:  this.caller.getFullName() + ' Daily New Published Sessions',
            axis: "main",
            color: "#f6921e",
            opposite: false
        });

        this.dailyViews.setYaxis(yaxis);

        let ranges = [];
        ranges.push({
            category: '',
            endCategory: '2021-11-30',
            fill: "#E56163",
            fillOpacity: 1,
            locationsCategory: 0.48,
            locationsEndCategory: 0.52,
        });

        this.dailyViews.setRanges(ranges);

        this.dailyViews.drawChart(dailyViews);
    }

    public hideDailyViewsChart(): void {
        this.dailyViews.hide();
    }

    public showDailyViewsChart(): void {
        this.dailyViews.show();
    }

    public getSelectedBrand()   {
        return this.brandFilter.getSelectedOption();
    }

    public resetPostPaymentCategoriesFilter() {
        this.paymentCategoryFilter.setSelectedItems([]);
    }

    public getSessionsRegionOption() {
        return this.sessionsRegionFilter.getTemplateViewModel().selectedOption();
    }

    public automaticDetectionOfDataRegionOption() {
        let sessionsRegionOption = this.getSessionsRegionOption();
        this.getTemplateViewModel().sessionsRegion(sessionsRegionOption);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/usersProfileArticlePerformance_template.ts